import React from "react";
import "./pbo.css";
import projectBasedImage from "../../../assets/service-pictures/project-based-outsourcing.jpg";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";

const ProjectBasedOutsourcing = () => {
  return (
    <div className="pbo-service-wrapper">
      <Particles title="Project Based Outsourcing" image={projectBasedImage} />
      <HeroSection />
      <OurApproach />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default ProjectBasedOutsourcing;
